module.exports = __webpack_public_path__ + "img/icon-building-blue-old.fbd96adb.svg";